import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SportsGolfMatchesWidget" */ './SportsGolfMatchesWidget'),
  modules: ['./SportsGolfMatchesWidget'],
  loading: () => <div />
});

export default LoadableWidget;
